import axios from "axios";
import { ENDPOINTS } from "../jsx/services/ENDPOINT";

const BASE_URL = ENDPOINTS.BASE_2;

const API = axios.create({
  baseURL: BASE_URL,
});

// A separate axios.create() instance doesn't inherit interceptors added to
// the plain `axios` import elsewhere (see axiosAuthInterceptor.js) — so
// this needs its own copy, or every request here goes out with no login
// token and gets rejected by the backend's auth check.
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ================================
// GET PDF CONFIG
// ================================
export const getPdfConfigAPI = async () => {
  try {
    const res = await API.get("/pdf-config/get-config");
    console.log("GET API Response:", res.data);
    
    // Your API returns { success: true, data: {...} }
    if (res.data && res.data.success) {
      return res.data.data; // Return the config object directly
    }
    return {}; // Return empty object if no config
  } catch (error) {
    console.error("Error in getPdfConfigAPI:", error);
    throw error;
  }
};

// ================================
// SAVE PDF CONFIG
// ================================
export const savePdfConfigAPI = async (data) => {
  try {
    const res = await API.post("/pdf-config/save-config", data);
    console.log("SAVE API Response:", res.data);
    return res.data; // Returns { success: true, message: "..." }
  } catch (error) {
    console.error("Error in savePdfConfigAPI:", error);
    throw error;
  }
};

// ================================
// DELETE PDF CONFIG
// ================================
export const deletePdfConfigAPI = async (id) => {
  try {
    const res = await API.delete(`/pdf-config/delete-config/${id}`);
    console.log("DELETE API Response:", res.data);
    return res.data; // Returns { success: true, message: "..." }
  } catch (error) {
    console.error("Error in deletePdfConfigAPI:", error);
    throw error;
  }
};